import { NcsNotificationFragment } from 'src/api/api.generated'

export enum NotificationType {
  INFO = 'HIC-Info',
  ALERT = 'HIC-Alert',
  RESERVATION = 'HIC-Reservation',
  MESSAGE = 'HIC-Message',
  NOT_DEFINED = 'HIC-NotDefined',
}

export type NotificationBellType = NcsNotificationFragment & {
  type: NotificationType
}

export const MAX_DAYS_NOTIFICATION = 7

export function getNotificationType(title: string) {
  let typeToReturn = NotificationType.NOT_DEFINED
  let titleToReturn = title

  for (const type of Object.values(NotificationType)) {
    if (title.includes(type)) {
      typeToReturn = type
      titleToReturn = title.replace(`[${type}]`, '').trim()
    }
  }

  return { type: typeToReturn, title: titleToReturn }
}
